export default __webpack_public_path__ + "static/media/fad-logo-reaper.84f6ba90.svg";